import React from 'react'
import ProTeacherExploreCourses from '../../features/proteacher/ProTeacherExploreCourses'

const ProTeacherExploreCoursesPage = () => {
    return (
        <ProTeacherExploreCourses />
    )
}

export default ProTeacherExploreCoursesPage
